export default __webpack_public_path__ + "static/media/Discover.c4bb33a9.svg";